module.exports = __webpack_public_path__ + "img/zuijia_49.326ce38a.png";